import React from 'react';

import moment from 'moment';

import { IWorkOrderBasic } from '../../declarations';

import Divider from '../common/Divider';
import LabeledRow from '../common/SectionCard/LabeledRow';
import SectionCard from '../common/SectionCard/SectionCard';
import SectionCardContent from '../common/SectionCard/SectionCardContent';

export interface IWorkOrderSectionProps {
  workOrders: IWorkOrderBasic[] | null;
}

export default class WorkOrderSection extends React.PureComponent<IWorkOrderSectionProps> {
  public renderNoWorkOrders(): JSX.Element {
    return (
      <SectionCardContent>
        Once repair work begins, we'll have work order documents available here.
      </SectionCardContent>
    );
  }

  public renderWorkOrders(): JSX.Element {
    const { workOrders } = this.props;

    return (
      <SectionCardContent>
        {workOrders.map((workOrder, idx) => (
          <div key={workOrder.id}>
            {idx !== 0 ? <Divider /> : null}
            <div className="work-order-details small-margin-bottom small-margin-top">
              <LabeledRow label="Vendor">{workOrder.vendor_name}</LabeledRow>
              <LabeledRow label="Status">{workOrder.display_state}</LabeledRow>
              <LabeledRow label="Last Updated">
                {moment(workOrder.updated_at).format('MMMM D')}
              </LabeledRow>
              <LabeledRow label="Details">
                <a href={`/dashboard/work-orders/${workOrder.reference_number}`}>
                  {workOrder.reference_number}
                </a>
              </LabeledRow>
            </div>
          </div>
        ))}
      </SectionCardContent>
    );
  }

  public render(): JSX.Element {
    const anyWorkOrders = this.props.workOrders != null && this.props.workOrders.length > 0;
    const workOrderSection = anyWorkOrders ? this.renderWorkOrders() : this.renderNoWorkOrders();

    return (
      <SectionCard id="work-order-section" headerText="Work Orders">
        {workOrderSection}
      </SectionCard>
    );
  }
}
